import { Button, Checkbox, DatePicker, Form, Input, message, Popover, Table } from "antd";
import { AiOutlineFieldTime } from "react-icons/ai";
import { TiSpannerOutline } from "react-icons/ti";
import { VscCheck, VscChromeClose } from "react-icons/vsc";
import { timeLap } from "../../utils/timeLap";
import Moment from "react-moment";
import { sameDay } from "../../utils/sameDay";
import getMetrics from "../../utils/getMetrics";
import { useEffect, useState } from "react";
import Timeline from "./components/Timeline";
import Services from "./components/Services";
import { RiFilterOffLine, RiMailSendLine } from "react-icons/ri";
import PageHeader from "../../components/shared/PageHeader";
import fetchDateVisistsAll from "../../services/fetchDateVisistsAll";
import { useSelector } from "react-redux";
import { REACT_APP_ARPS_BASE_URL } from "../../utils/urls";
import getServiceHistory from "../../utils/getServiceHistory";
import moment from "moment";
import searchDateVisistsAll from "../../services/searchDateVisistsAll";
import { BiExport } from "react-icons/bi";
import { blobToDataUrl, ExportToExcel, getExportData } from "../../utils/XLSXExport";
import { useSendEmailMutation } from "../../store/endpoints/email/email";
import _ from "lodash";
import CheckpointWidget from "./components/SegmentWidget";
import fetchDataArps from "../../services/fetchDataArps";
import StationVehicles from "./components/StationVehicles";
const { RangePicker } = DatePicker;

const { Search } = Input;

export default function AllVisits() {
  const { selectedSite } = useSelector((state: any) => state.site);
  const [visits, setVisits] = useState<any>([]);
  const [irevenues, setRevenues] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [booking, setBooking] = useState<any[]>([]);

  const [showTimeline, setShowTimeline] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const [showTimelin, setShowTimelin] = useState(false);
  const [selected, setSelected] = useState();
  const [search, setSearch] = useState("");
  const [showRange, setShowRange] = useState(false);
  const [services, setServices] = useState<any>([]);
  const [invoiced, setInvoiced] = useState<any>([]);
  const [detailModal, setDetailModal] = useState<boolean>(false);
  const [stationVehicles, setStationVehicles] = useState<any>([]);
  const [stationTitle, setStationTitle] = useState<any>([]);
  const [startDate, setStateDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [serviceStartDate, setServiceStateDate] = useState(
    moment(new Date()).format("YYYYMMDD")
  );
  const [serviceEndDate, setServiceEndDate] = useState(
    moment(new Date()).format("YYYYMMDD")
  );

  const [messageModal, toggleMessageModal] = useState(false);
  const [sendEmail, emailResult] = useSendEmailMutation();
  const [emailForm] = Form.useForm();

  const [checkpoints, setCheckpoints]: any = useState({
    "Body and Paint Center": [],
    "Express Lane": [],
    "Service / Delivery Parking": [],
    "Testing Lane": [],
    "Waiting for customer approval": [],
    "Washing Bay": [],
    "Workshop 1": [],
    "Workshop 2": [],
    "Workshop 3": [],
  });

  const sendMail = async (values: any, vehicles: any) => {
    const raw = getExportData(vehicles);
    const uri = await blobToDataUrl(raw);

    sendEmail({
      email: values.email,
      subject: values.subject,
      data: uri,
    });

    message.success("Email Sent Successfully");
    emailForm.resetFields();
    toggleMessageModal(false);
  };

  useEffect(() => {
    if (emailResult.isSuccess) {
      message.success("Email Sent Successfully");
    }
  }, [emailResult]);

  const [form] = Form.useForm();

  const nove = visits.filter((visit: any) => visit?.vehicle !== null);

  const filtered = nove.filter(
    (visit: any) =>
      visit?.timein !== visit?.timeout &&
      timeLap(visit?.timein, visit?.timeout).trim() != "0 sec"
  );

  const { exited, stayed, total } = getMetrics(filtered);

  const site_id = selectedSite?._id || "6224dcf60c5c49d9fec9218f";

  const handleFetchVisits = async () => {
    setLoading(true);
    const data = await fetchDateVisistsAll(site_id, startDate, endDate);
    setVisits(data.payload);
    setLoading(false);
  };

  const handleSearchVisits = async (registration: any) => {
    setLoading(true);
    const data = await searchDateVisistsAll(site_id, registration);

    const { timein } = data?.payload[0];

    setServiceStateDate(moment(new Date(timein)).format("YYYYMMDD"));
    setServiceEndDate(moment(new Date()).format("YYYYMMDD"));

    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/service?start=${serviceStartDate}&end=${serviceEndDate}`
    );

    const servs = await response.json();
    const res = getServiceHistory(servs);

    let invArray = res.filter(
      (value: any, index: any, self: any) =>
        index ===
        self.findIndex(
          (t: any) =>
            t.registration === value.registration && t.name === value.name
        )
    );

    invArray.forEach((item: any) => {
      exists.push(item.registration);
    });

    setInvoiced(exists);
    setServices(res);

    setVisits(data.payload);
    setLoading(false);
  };

  let exists: any = [];

  const fetchServices = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/service?start=${serviceStartDate}&end=${serviceEndDate}`
    );
    const data = await response.json();
    const res = getServiceHistory(data);

    let invArray = res.filter(
      (value: any, index: any, self: any) =>
        index ===
        self.findIndex(
          (t: any) =>
            t.registration === value.registration && t.name === value.name
        )
    );

    invArray.forEach((item: any) => {
      exists.push(item.registration);
    });

    setInvoiced(exists);
    setServices(res);
    setLoading(false);
  };

  const handleSelected = ({ name, values }: any) => {
    setDetailModal(true);
    setStationTitle(name);
    setStationVehicles(values);
  };

  const handleSearchServices = async (registration: any) => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/service/search/vehicles/${registration}`
    );
    const data = await response.json();
    const res = getServiceHistory(data);

    let invArray = res.filter(
      (value: any, index: any, self: any) =>
        index ===
        self.findIndex(
          (t: any) =>
            t.registration === value.registration && t.name === value.name
        )
    );

    invArray.forEach((item: any) => {
      exists.push(item.registration);
    });

    setInvoiced(exists);
    setServices(res);
    setLoading(false);
  };

  let invoicedVisits = visits.filter(function (val: any) {
    return invoiced.indexOf(val.vehicle?.registration) != -1;
  });

  let nonInvoicedVisits = visits.filter(function (val: any) {
    return invoiced.indexOf(val.vehicle?.registration) == -1;
  });

  const operators: any = {
    " 113 ": "Samweli Kitomari",
    " 69 ": "Anna Mzori",
    " 5 ": "Fatuma Suleiman",
    " 104 ": "Noela Soka",
    " 6 ": "Anna Chaulo",
    " 27 ": "Diana Laizer",
    " 4 ": "Juliana Sendwa",
    " 48 ": "Consolata Begina",
    " 112 ": "Ruth Kulindwa",
    "0113": "Samweli Kitomari",
    "0069": "Anna Mzori",
    "0005": "Fatuma Suleiman",
    "0104": "Noela Soka",
    "0006": "Anna Chaulo",
    "0027": "Diana Laizer",
    "0004": "Juliana Sendwa",
    "0048": "Consolata Begina",
    "0112": "Ruth Kulindwa",
  };

  const extractCheckpoints = async () => {
    const cpoints: any = await _.groupBy(
      _.flatten(visits.map((visit: any) => [...visit.checkpoints])),
      (cpoint: any) => cpoint.station.name
    );
    setCheckpoints(cpoints);
  };

  const getWips = async () => {
    const wipUrl = `wip/owner?start=${serviceStartDate}&end=${serviceEndDate}`;
    const result = await fetchDataArps(wipUrl);
    setBooking(result);
  };

  useEffect(() => {
    handleFetchVisits();
    fetchServices();
    getWips();
  }, [startDate, selectedSite]);

  useEffect(() => {
    extractCheckpoints();
  }, [visits]);

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Registration",
      width: 80,
      render: (record: any) => (
        <div className="text-gray-700 truncate">{record?.vehicle?.registration}</div>
      ),
    },
    {
      title: "Chassis Number",
      width: 120,
      render: (record: any) => (
        <div className="text-gray-700 truncate">{record?.vehicle?.chassis}</div>
      ),
    },
    {
      title: "Arrived At",
      width: 140,
      render: (record: any) => (
        <span className="text-gray-700">
          <Moment format="Do, MMM YYYY hh:mm A">{record?.timein}</Moment>
        </span>
      ),
    },
    {
      title: "Exited At",
      width: 140,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.timeout ? (
            <Moment format="Do, MMM YYYY hh:mm A" className="text-green-600">
              {record?.timeout}
            </Moment>
          ) : (
            <span className="text-yellow-600">Work in progress</span>
          )}
        </span>
      ),
    },
    {
      title: "Exited Today",
      width: 80,
      render: (record: any) => (
        <span className="text-gray-700">
          {sameDay(new Date(record?.timein), new Date(record?.timeout)) ? (
            <span className="flex items-center">
              <VscCheck color="#16A34A" /> <span className="ml-1">Yes</span>
            </span>
          ) : (
            <span className="flex items-center">
              <VscChromeClose color="#E31513" />
              <span className="ml-1">No</span>
            </span>
          )}
        </span>
      ),
    },
    {
      title: "Time Taken",
      width: 160,
      render: (record: any) => (
        <span className="text-gray-700">
          {timeLap(record?.timein, record?.timeout)}
        </span>
      ),
    },
    {
      title: "Timeline",
      width: 100,
      render: (record: any) => (
        <button
          onClick={() => {
            setShowTimeline(true);
            setSelected(record);
          }}
          className="flex justify-center items-center text-gray-700 border rounded-md px-4 py-1 bg-blue-100 hover:bg-blue-200 cursor-pointer"
        >
          <AiOutlineFieldTime />
          <span className="ml-1">Timeline</span>
        </button>
      ),
    },
    {
      title: "Services",
      width: 100,
      render: (record: any) => {
        if (invoiced.indexOf(`${record?.vehicle?.registration}`) !== -1) {
          return (
            <button
              onClick={() => {
                setShowServices(true);
                setSelected(record);
              }}
              className="flex justify-center items-center text-gray-700 border rounded-md px-4 py-1 bg-green-100 hover:bg-green-200 cursor-pointer"
            >
              <TiSpannerOutline />
              <span className="ml-1">Services</span>
            </button>
          );
        } else {
          return null;
        }
      },
    },
  ];

  const onDateChange = (date: any) => {
    setStateDate(new Date(date));
    setEndDate(new Date(date));
    setServiceStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setServiceEndDate(moment(new Date()).format("YYYYMMDD"));
  };

  const onRangeChange = (date: any) => {
    setStateDate(new Date(date[0]));
    setEndDate(new Date(date[1]));
    setServiceStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setServiceEndDate(moment(new Date()).format("YYYYMMDD"));
  };

  const clearDate = () => {
    form.resetFields();
    setStateDate(new Date());
    setEndDate(new Date());
    setServiceStateDate(moment(new Date()).format("YYYYMMDD"));
    setServiceEndDate(moment(new Date()).format("YYYYMMDD"));
    setSearch("");
  };

  return (
    <div className=" bg-gray-100">
      <div className="flex justify-between items-center border-b border-gray-300 py-2 mx-4">
        <div className="flex">
          <Form layout="inline" form={form}>
            <Form.Item name="registration">
              <Search
                placeholder="Search by registration"
                allowClear
                // onChange={(val: any) => {
                //   setSearch(val.target.value);
                // }}
                onSearch={(value: any) => {
                  handleSearchVisits(value);
                }}
              />
            </Form.Item>
            {showRange ? (
              <div className="flex justify-center items-center">
                <Form.Item name="ranger">
                  <RangePicker
                    allowClear={true}
                    onChange={onRangeChange}
                    format={"DD-MM-YYYY"}
                  />
                </Form.Item>

                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <Form.Item name="picker">
                  <DatePicker
                    onChange={onDateChange}
                    format={"DD-MM-YYYY"}
                    placeholder="Specific date"
                  />
                </Form.Item>
                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            )}

            <Button className="" onClick={() => clearDate()}>
              <RiFilterOffLine color="#6b7280" />
            </Button>
          </Form>
        </div>
        <div className="flex ">
          <div className="mr-2">
            <span className="text-green-600 font-bold">Exited :</span>
            <span className="font-bold text-gray-600 ml-1">{exited}</span>
          </div>
          <div className="mr-2">
            <span className="text-red-600 font-bold">Stayed :</span>
            <span className="font-bold text-gray-600 ml-1">{stayed}</span>
          </div>
          <div className="">
            <span className="text-blue-600 font-bold">Total :</span>
            <span className="font-bold text-gray-600 ml-1">{total}</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white">
        <div className="">
          <PageHeader
            title="Vehicle Visits"
            subtitle="List of vehicle visits"
            tag="List"
            actions={
              <div className="flex justify-start flex-row items-start">
                <Popover
                  content={
                    <>
                      <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        form={emailForm}
                        onFinish={(values: any) =>
                          sendMail(
                            values,
                            [...invoicedVisits, ...nonInvoicedVisits]
                              .filter(
                                (visit: any) =>
                                  visit?.vehicle?.registration.includes(
                                    search
                                  ) &&
                                  timeLap(
                                    visit?.timein,
                                    visit?.timeout
                                  ).trim() != "0 sec"
                              )
                              .map((record: any, index: number) => {
                                const stationDuration = (
                                  local_checkpoints: any,
                                  search: string
                                ) => {
                                  const location_data = local_checkpoints.find(
                                    (location: any) =>
                                      location.station.name
                                        .toLowerCase()
                                        .includes(search.toLowerCase())
                                  );

                                  if (location_data) {
                                    return timeLap(
                                      location_data?.timein,
                                      location_data?.timeout
                                    );
                                  }

                                  return;
                                };

                                const serviveHistory = services.find(
                                  (service: any) =>
                                    service.registration ===
                                    record?.vehicle?.registration
                                );

                                const formatDate = (date: number) => {
                                  if (date == null || date == undefined) {
                                    return null;
                                  }

                                  return moment(date, "YYYYMMDD").format(
                                    "Do, MMM YYYY"
                                  );
                                };

                                let wip: any = null;
                                let advisor: string = "";
                                let status: string = "";

                                if (serviveHistory?.wip) {
                                  wip = serviveHistory?.wip;
                                  advisor = serviveHistory?.operator;
                                } else {
                                  const book = _.find(
                                    booking,
                                    (b: any) =>
                                      b.registration ===
                                      record?.vehicle?.registration
                                  );
                                  wip = book?.wip;
                                  advisor = book?.owner;
                                  status = book?.status;
                                }

                                if (wip) {
                                  const book = _.find(
                                    booking,
                                    (b: any) => b.wip === wip
                                  );
                                  if (book) {
                                    advisor = book?.owner;
                                    status = book?.status;
                                  }
                                }

                                return {
                                  "S/N": index + 1,
                                  Registration: record?.vehicle?.registration,
                                  "Chassis Number": record?.vehicle?.chassis,
                                  "Customer Name":
                                    record?.vehicle?.contact?.customer?.name,
                                  "Customer Email":
                                    record?.vehicle?.contact?.customer?.email,
                                  "Customer Mobile":
                                    record?.vehicle?.contact?.customer?.phone,
                                  "Time In": moment(record?.timein).format(
                                    "Do, MMM YYYY hh:mm A"
                                  ),
                                  "Time Out":
                                    record?.timeout !== null
                                      ? moment(record?.timeout).format(
                                          "Do, MMM YYYY hh:mm A"
                                        )
                                      : null,
                                  "Exited Today": sameDay(
                                    new Date(record?.timein),
                                    new Date(record?.timeout)
                                  )
                                    ? "Yes"
                                    : "No",
                                  "Time Taken": timeLap(
                                    record?.timein,
                                    record?.timeout
                                  ),
                                  WIP: wip,
                                  "Wip Status": status,
                                  Advisor: advisor
                                    ? operators[`${advisor.trim()}`]
                                    : advisor,
                                  "Service Details":
                                    serviveHistory?.service_details,
                                  "Invoice Value": serviveHistory
                                    ? new Intl.NumberFormat("sw").format(
                                        serviveHistory?.invoice_value
                                      )
                                    : null,
                                  "Express Lane": stationDuration(
                                    record.checkpoints,
                                    "express"
                                  ),
                                  "Workshop 1": stationDuration(
                                    record.checkpoints,
                                    "workshop 1"
                                  ),
                                  "Workshop 2": stationDuration(
                                    record.checkpoints,
                                    "workshop 2"
                                  ),
                                  "Workshop 3": stationDuration(
                                    record.checkpoints,
                                    "workshop 3"
                                  ),
                                  "Body and Paint": stationDuration(
                                    record.checkpoints,
                                    "body"
                                  ),
                                  "Washing Bay": stationDuration(
                                    record.checkpoints,
                                    "washing"
                                  ),
                                  "Testing Lane": stationDuration(
                                    record.checkpoints,
                                    "test"
                                  ),
                                  "Waiting Customer Approval": stationDuration(
                                    record.checkpoints,
                                    "approval"
                                  ),
                                  "Service Date": formatDate(
                                    serviveHistory?.service_date
                                  ),
                                  "Last Service Date": formatDate(
                                    serviveHistory?.last_service_date
                                  ),
                                  "Next Service Date": formatDate(
                                    serviveHistory?.next_service_date
                                  ),
                                };
                              })
                          )
                        }
                        autoComplete="off"
                      >
                        <Form.Item
                          label="Email"
                          name="email"
                          rules={[
                            { required: true, message: "Email is Required" },
                          ]}
                        >
                          <Input placeholder="Email" />
                        </Form.Item>
                        <Form.Item
                          label="Subject"
                          name="subject"
                          rules={[
                            { required: true, message: "Subject is Required" },
                          ]}
                        >
                          <Input placeholder="Email Subject" />
                        </Form.Item>
                        <div className="flex flex-row justify-between">
                          <Form.Item wrapperCol={{ offset: 12, span: 8 }}>
                            <Button type="primary" htmlType="submit">
                              Submit
                            </Button>
                          </Form.Item>

                          <Form.Item wrapperCol={{ offset: 0, span: 8 }}>
                            <Button
                              onClick={() => {
                                toggleMessageModal(false);
                              }}
                            >
                              Cancel
                            </Button>
                          </Form.Item>
                        </div>
                      </Form>
                    </>
                  }
                  title="Message Content"
                  trigger="focus"
                  placement="left"
                  visible={messageModal}
                  // onVisibleChange={}
                >
                  <button className="flex ml-4 justify-center items-center border p-1 px-3 hover:bg-green-100">
                    <RiMailSendLine size={24} />
                    <span
                      className="ml-2"
                      onClick={async () => {
                        toggleMessageModal(true);
                      }}
                    >
                      Send Email
                    </span>
                  </button>
                </Popover>
                <button className="border-l px-2 ml-2 flex items-center border p-1 border-gray-300 bg-white hover:bg-red-100">
                  <BiExport />
                  <span
                    className="ml-2"
                    onClick={() => {
                      ExportToExcel(
                        [...invoicedVisits, ...nonInvoicedVisits]
                          .filter(
                            (visit: any) =>
                              visit?.vehicle?.registration.includes(search) &&
                              timeLap(visit?.timein, visit?.timeout).trim() !=
                                "0 sec"
                          )
                          .map((record: any, index: number) => {
                            const stationDuration = (
                              local_checkpoints: any,
                              search: string
                            ) => {
                              const location_data = local_checkpoints.find(
                                (location: any) =>
                                  location.station.name
                                    .toLowerCase()
                                    .includes(search.toLowerCase())
                              );

                              if (location_data) {
                                return timeLap(
                                  location_data?.timein,
                                  location_data?.timeout
                                );
                              }

                              return;
                            };

                            const serviveHistory = services.find(
                              (service: any) =>
                                service.registration ===
                                record?.vehicle?.registration
                            );

                            const formatDate = (date: number) => {
                              if (date == null || date == undefined) {
                                return null;
                              }

                              return moment(date, "YYYYMMDD").format(
                                "Do, MMM YYYY"
                              );
                            };

                            let wip: any = null;
                            let advisor: string = "";
                            let status: string = "";

                            if (serviveHistory?.wip) {
                              wip = serviveHistory?.wip;
                              advisor = serviveHistory?.operator;
                            } else {
                              const book = _.find(
                                booking,
                                (b: any) =>
                                  b.registration ==
                                  record?.vehicle?.registration
                              );
                              wip = book?.wip;
                              advisor = book?.owner;
                              status = book?.status;
                            }

                            if (wip) {
                              const book = _.find(
                                booking,
                                (b: any) => b.wip == wip
                              );
                              if (book) {
                                advisor = book?.owner;
                                status = book?.status;
                              }
                            }

                            return {
                              "S/N": index + 1,
                              Registration: record?.vehicle?.registration,
                              "Chassis Number": record?.vehicle?.chassis,
                              "Customer Name":
                                record?.vehicle?.contact?.customer?.name,
                              "Customer Email":
                                record?.vehicle?.contact?.customer?.email,
                              "Customer Mobile":
                                record?.vehicle?.contact?.customer?.phone,
                              "Time In": moment(record?.timein).format(
                                "Do, MMM YYYY hh:mm A"
                              ),
                              "Time Out":
                                record?.timeout !== null
                                  ? moment(record?.timeout).format(
                                      "Do, MMM YYYY hh:mm A"
                                    )
                                  : null,
                              "Exited Today": sameDay(
                                new Date(record?.timein),
                                new Date(record?.timeout)
                              )
                                ? "Yes"
                                : "No",
                              "Time Taken": timeLap(
                                record?.timein,
                                record?.timeout
                              ),
                              WIP: wip,
                              "WIP Status": status,
                              Advisor: advisor
                                ? operators[`${advisor?.trim()}`]
                                : advisor,
                              "Service Details":
                                serviveHistory?.service_details,
                              "Invoice Value": serviveHistory
                                ? new Intl.NumberFormat("sw").format(
                                    serviveHistory?.invoice_value
                                  )
                                : null,
                              "Express Lane": stationDuration(
                                record.checkpoints,
                                "express"
                              ),
                              "Workshop 1": stationDuration(
                                record.checkpoints,
                                "workshop 1"
                              ),
                              "Workshop 2": stationDuration(
                                record.checkpoints,
                                "workshop 2"
                              ),
                              "Workshop 3": stationDuration(
                                record.checkpoints,
                                "workshop 3"
                              ),
                              "Body and Paint": stationDuration(
                                record.checkpoints,
                                "body"
                              ),
                              "Washing Bay": stationDuration(
                                record.checkpoints,
                                "washing"
                              ),
                              "Testing Lane": stationDuration(
                                record.checkpoints,
                                "test"
                              ),
                              "Waiting Customer Approval": stationDuration(
                                record.checkpoints,
                                "approval"
                              ),
                              "Service Date": formatDate(
                                serviveHistory?.service_date
                              ),
                              "Last Service Date": formatDate(
                                serviveHistory?.last_service_date
                              ),
                              "Next Service Date": formatDate(
                                serviveHistory?.next_service_date
                              ),
                            };
                          }),
                        "visits.xlsx"
                      );
                    }}
                  >
                    Export All
                  </span>
                </button>
              </div>
            }
          />

          <div className="m-4">
            <div className="grid grid-cols-12 gap-2 mb-4">
              {checkpoints &&
                _.keys(checkpoints).map((key: string) => (
                  <CheckpointWidget
                    name={key}
                    values={checkpoints[key]}
                    handleSelected={handleSelected}
                  />
                ))}
            </div>
          </div>

          <div className="grid gap-x-0 grid-cols-12">
            <div className="col-span-12 sm:col-span-12 md:col-span-12">
              <Table
                columns={columns}
                dataSource={filtered.sort((a: any, b: any) => {
                  const a_sort =
                    invoiced.indexOf(a.vehicle?.registration) != -1;
                  if (a_sort) {
                    return -1;
                  }
                  return 1;
                })}
                size="small"
                pagination={false}
                scroll={{ y: 700, x: 0 }}
                loading={loading}
                rowKey="id"
              />
              <Timeline
                isVisible={showTimeline}
                setShowTimeline={setShowTimeline}
                selected={selected}
              />
              <Services
                isVisible={showServices}
                setShowTimelin={setShowTimelin}
                setShowServices={setShowServices}
                selected={selected}
                services={irevenues}
                startDate={startDate}
                endDate={endDate}
              />

              <StationVehicles
                isVisible={detailModal}
                setVisible={setDetailModal}
                vehicles={stationVehicles}
                title={stationTitle}
                refetch={() => {}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}